import Link from 'next/link';
import { MainLayout } from '@/widgets/layouts/main';
import { Article } from '@/shared/components/article';
import { PageSeo } from '@/shared/lib/seo';
export const PrivacyPolicyPage = () => {
  return <>
      <PageSeo title="Политика обработки персональных данных" description="Политика в отношении обработки персональных данных. Enlerno – деловой английский для работы." noindex />

      <Article tag="main" className="select-none">
        <h1 className="mb-20 text-center header-h1">Политика в отношении обработки персональных данных</h1>

        <section className="mx-auto mb-10 max-w-6xl space-y-2">
          <p>
            Настоящая Политика разработана в соответствии с пунктом 2 статьи 18.1 Федерального закона от 27.07.2006 №
            152-ФЗ «О персональных данных» (далее – 152-ФЗ) и определяет позицию Индивидуального предпринимателя Сладких
            Анны Святославовны (ИНН 745312661384, ОГРНИП 323745600057252) (далее – Оператор) в отношении обработки
            персональных данных.
          </p>

          <p>
            Политика применяется к обработке персональных данных на сайте https://enlerno.ru (включая поддомены) и на
            платформе https://study.enlerno.ru и является дополнением к{' '}
            <Link href="/agreement" className="underline">
              Согласию на обработку персональных данных
            </Link>{' '}
            и{' '}
            <Link href="/public-offer" className="underline">
              Договору-оферте
            </Link>
            . Настоящая Политика не заменяет указанные документы, а раскрывает подход Оператора к обработке персональных
            данных в целом, независимо от факта обращения конкретного субъекта.
          </p>
        </section>

        <section className="mx-auto mb-10 max-w-6xl space-y-2">
          <h2 className="mb-4 header-h3">1. Цели обработки персональных данных</h2>

          <ul className="list-inside list-decimal space-y-1">
            <li>Обработка входящих запросов на получение обучающих материалов и обратной связи с сайта;</li>
            <li>Аналитика действий пользователя на сайте и обеспечение его функционирования;</li>
            <li>Проведение рассылки новостей и информационных материалов;</li>
            <li>Предоставление доступа к платформе, создание и сопровождение учетной записи;</li>
            <li>Организация и проведение занятий по английскому языку, планирование расписания, учет прогресса;</li>
            <li>
              Исполнение договора об оказании услуг, заключаемого на условиях публичной оферты
              https://enlerno.ru/public-offer, включая прием и учет оплаты.
            </li>
          </ul>
        </section>

        <section className="mx-auto mb-10 max-w-6xl space-y-2">
          <h2 className="mb-4 header-h3">2. Правовые основания обработки персональных данных</h2>

          <p>
            Обработка осуществляется на основании ст. 24 Конституции Российской Федерации, ст. 6 152-ФЗ, согласия
            субъекта персональных данных, а также договора, заключенного с субъектом персональных данных (в случае его
            заключения) на условиях публичной оферты.
          </p>
        </section>

        <section className="mx-auto mb-10 max-w-6xl space-y-2">
          <h2 className="mb-4 header-h3">3. Категории субъектов персональных данных</h2>

          <p>
            Оператор обрабатывает персональные данные посетителей сайта, оставивших заявку через форму обратной связи, а
            также лиц, зарегистрированных и/или использующих платформу (заказчиков услуг и учеников). Данные
            несовершеннолетних лиц, не достигших 14 лет, обрабатываются только на основании согласия, предоставленного
            их законным представителем.
          </p>
        </section>

        <section className="mx-auto mb-10 max-w-6xl space-y-2">
          <h2 className="mb-4 header-h3">4. Перечень и категории обрабатываемых персональных данных</h2>

          <p>
            Оператор обрабатывает следующие персональные данные, не являющиеся специальными или биометрическими и не
            являющиеся общедоступными:
          </p>

          <ul className="list-inside list-decimal space-y-1">
            <li>
              номер телефона и/или никнейм в мессенджере Telegram — указывается Пользователем в форме обратной связи на
              сайте;
            </li>

            <li>фамилия, имя и адрес электронной почты — указываются Пользователем при оформлении оплаты услуг;</li>

            <li>
              данные учетной записи платформы (логин и иные идентификаторы), а также сведения, связанные с организацией
              и проведением занятий (расписание, посещаемость, выполненные задания, прогресс) — при использовании
              платформы;
            </li>

            <li>
              технические и пользовательские данные (сведения о местоположении; тип и версия операционной системы и
              браузера; тип устройства и разрешение его экрана; источник перехода на сайт; язык операционной системы и
              браузера; действия пользователя на сайте; IP-адрес) — собираются автоматически при использовании сайта и
              платформы.
            </li>
          </ul>
        </section>

        <section className="mx-auto mb-10 max-w-6xl space-y-2">
          <h2 className="mb-4 header-h3">5. Действия, совершаемые с персональными данными</h2>

          <p>
            Как с использованием средств автоматизации, так и без их использования: сбор; запись; систематизация;
            накопление; хранение; уточнение (обновление, изменение); извлечение; использование; передача
            (распространение, предоставление, доступ); блокирование; удаление; уничтожение.
          </p>
        </section>

        <section className="mx-auto mb-10 max-w-6xl space-y-2">
          <h2 className="mb-4 header-h3">6. Передача персональных данных третьим лицам</h2>

          <ul className="list-inside list-decimal space-y-1">
            <li>
              <strong>ООО «ПрогрессМи» (сервис ProgressMe).</strong> Оператор поручает ООО «ПрогрессМи» обработку
              персональных данных пользователей платформы на основании ч. 3 ст. 6 152-ФЗ и п. 5.12 Пользовательского
              соглашения ProgressMe (https://progressme.ru/legal/terms) в целях предоставления технической
              инфраструктуры платформы (учетные записи, проведение занятий, расписание, учет заданий и прогресса).
              Оператор сохраняет статус оператора персональных данных, самостоятельно определяет цели обработки и
              самостоятельно отвечает на запросы субъектов персональных данных. Отсутствие у Оператора прямого доступа к
              паролям Пользователя и к базе данных Платформы не исключает статуса Оператора.
            </li>

            <li>
              <strong>Операторы платежных сервисов.</strong> Для целей приема оплаты услуг Оператор передает необходимый
              минимум персональных данных (фамилию, имя, адрес электронной почты, сведения о платеже) организациям,
              обеспечивающим прием платежей — PayKeeper и ЮKassa. Указанные организации самостоятельно хранят и
              обрабатывают эти данные как отдельные операторы персональных данных, действующие в силу собственных
              законных обязанностей (в частности, Федерального закона №115-ФЗ «О противодействии легализации (отмыванию)
              доходов, полученных преступным путем, и финансированию терроризма» и Федерального закона №161-ФЗ «О
              национальной платежной системе»), а не по поручению Оператора.
            </li>

            <li>
              <strong>Сервисы веб-аналитики.</strong> Для целей аналитики действий пользователей на сайте и
              функционирования сайта Оператор использует Яндекс.Метрика и Google Tag
            </li>
          </ul>
        </section>

        <section className="mx-auto mb-10 max-w-6xl space-y-2">
          <h2 className="mb-4 header-h3">7. Сроки обработки и хранения персональных данных</h2>

          <p>
            Персональные данные обрабатываются в течение срока, необходимого для достижения целей обработки: до отписки
            пользователя от рассылки; в течение срока использования платформы и исполнения договора об оказании услуг, —
            а также в сроки, установленные законодательством Российской Федерации. Хранение персональных данных,
            зафиксированных на бумажных носителях, осуществляется в соответствии с Федеральным законом №125-ФЗ «Об
            архивном деле в Российской Федерации» и иными нормативно-правовыми актами в области архивного дела и
            архивного хранения.
          </p>
        </section>

        <section className="mx-auto mb-10 max-w-6xl space-y-2">
          <h2 className="mb-4 header-h3">8. Меры по обеспечению безопасности персональных данных</h2>

          <p>
            Оператор принимает необходимые правовые, организационные и технические меры для защиты персональных данных
            от неправомерного или случайного доступа, уничтожения, изменения, блокирования, копирования, предоставления,
            распространения, а также от иных неправомерных действий в соответствии со ст. 19 152-ФЗ. В части обработки
            персональных данных на платформе соответствующие меры также обеспечиваются ООО «ПрогрессМи» в рамках
            поручения обработки.
          </p>
        </section>

        <section className="mx-auto mb-10 max-w-6xl space-y-2">
          <h2 className="mb-4 header-h3">9. Права субъекта персональных данных</h2>

          <p>Субъект персональных данных вправе:</p>

          <ul className="list-inside list-decimal space-y-1">
            <li>получать информацию, касающуюся обработки его персональных данных (ст. 14 152-ФЗ);</li>
            <li>
              требовать уточнения, блокирования или уничтожения персональных данных в случае, если они являются
              неполными, устаревшими, недостоверными, незаконно полученными или не являются необходимыми для заявленной
              цели обработки;
            </li>
            <li>
              отозвать согласие на обработку персональных данных в порядке, предусмотренном{' '}
              <Link href="/agreement" className="underline">
                Согласием на обработку персональных данных
              </Link>
              ;
            </li>
            <li>обращаться с запросами к Оператору по вопросам обработки его персональных данных;</li>
            <li>
              обжаловать действия или бездействие Оператора в уполномоченный орган по защите прав субъектов персональных
              данных (Роскомнадзор) либо в судебном порядке.
            </li>
          </ul>
        </section>

        <section className="mx-auto mb-10 max-w-6xl space-y-2">
          <h2 className="mb-4 header-h3">10. Порядок обращения субъектов персональных данных</h2>

          <p>
            Запросы и обращения по вопросам обработки персональных данных направляются на электронную почту Оператора:{' '}
            {process.env.NEXT_PUBLIC_EMAIL_URL ?? ''}. Оператор рассматривает поступившие обращения в сроки,
            установленные 152-ФЗ.
          </p>
        </section>

        <section className="mx-auto mb-10 max-w-6xl space-y-2">
          <h2 className="mb-4 header-h3">11. Заключительные положения</h2>

          <p>
            Оператор вправе вносить изменения в настоящую Политику. Действующая редакция Политики размещена на сайте
            https://enlerno.ru/privacy-policy и применяется с момента ее публикации. Настоящая Политика действует без
            ограничения срока до ее замены новой редакцией.
          </p>
        </section>
      </Article>
    </>;
};
PrivacyPolicyPage.Layout = MainLayout;